<template>
  <div id="author-selection">
    <ipub-model title="Submitted Author Selection"
                width="1000px"
                :visable="isVisable"
                :showFooter="false"
                @cancel="cancel"
                @confirm="confirm">
      <div class="ipub-p2 mar-b-20">
        <div class="fw-bd">The system has detected that you are not in the author queue, please select the author to whom the manuscript belongs:</div>
      </div>
      <div v-if="authorList && authorList.length>0"
           class="mar-b-30">
        <ipub-radio-group v-model="authorId">
          <ipub-radio v-for="val in authorList"
                      class="mar-b-10"
                      style="display:block;margin-left:0"
                      :value="val.id"
                      :key="val.id">
            {{title[val.titleCode]}} {{val.firstName}} {{val.lastName}} ({{val.email}})
            <ipub-label size="small"
                        class="mar-l-10"
                        v-if="val.firsted">First Author</ipub-label>
            <ipub-label size="small"
                        class="mar-l-10"
                        v-if="val.submited">Submitted</ipub-label>
            <ipub-label size="small"
                        class="mar-l-10"
                        v-if="val.corresponded">Correspondence Author</ipub-label>
          </ipub-radio>
        </ipub-radio-group>
      </div>
      <div>
        <ipub-button plain
                     style="width:150px"
                     type="primary"
                     @click="cancel">cancel</ipub-button>
        <ipub-button @click="confirm"
                     style="width:150px"
                     type="primary"
                     :disabled="!authorId">confirm</ipub-button>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Array,
      default () {
        return []
      },
    },
  },
  data () {
    return {
      authorList: [],
      authorId: ''
    }
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.authorList = []
      } else {
        this.authorList = this.inputData
      }
    }
  },
  mounted () {

  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      journalId: 'getJournalId',
      title: 'getTitle',
      domain: 'getDomain',
      country: 'getCountry',
    })
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    confirm () {
      this.$emit('confirm', this.authorId)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
